/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'linkedin': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" _fill="#0084b1" d="M0 0h32v32H0V0z"/><path pid="1" _fill="#fff" d="M7.531 4.86a2.689 2.689 0 012.671 2.685c-.004 1.542-1.283 2.705-2.689 2.671-1.426.029-2.679-1.162-2.679-2.681 0-1.473 1.213-2.676 2.697-2.675zM9.088 27.137h-3.14a.737.737 0 01-.738-.738V13.003c0-.408.33-.738.738-.738h3.14c.408 0 .738.33.738.738v13.396c0 .407-.33.738-.738.738zM27.166 16.97a5.085 5.085 0 00-5.085-5.085h-.805a4.513 4.513 0 00-3.957 2.335.247.247 0 00-.042-.005v-1.644a.306.306 0 00-.306-.306h-3.918a.306.306 0 00-.306.306V26.83c0 .169.137.306.306.306l4.003.001a.306.306 0 00.306-.306v-8.238c0-1.424 1.136-2.606 2.56-2.622a2.582 2.582 0 011.861.758c.469.468.758 1.116.758 1.831v8.272c0 .169.137.306.306.306l4.013.001a.306.306 0 00.306-.306V16.97z"/>'
  }
})
